<div class="row" *ngFor="let item of unifyList">
  <div class="row-line">
    <p [ngStyle]="{ width: tableHeader[0].percentageWidth + '%' }" class="name">
      {{ item.name }} {{ item.lastname }}
    </p>
    <p
      [ngStyle]="{ width: tableHeader[1].percentageWidth + '%' }"
      class="closing"
    >
      {{ userCurrency == "USD" ? "U$S " : "$ " }} {{ formatNumber(item.close) }}
    </p>
    <p
      [ngStyle]="{ width: tableHeader[2].percentageWidth + '%' }"
      class="transactions"
    >
      {{ item.transaction }}
    </p>
  </div>
</div>
<div class="empty" *ngIf="unifyList.length == 0">
  <h2 class="display-02-semi-bold">Ningún resultado</h2>
</div>
